import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=32790ab2&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"
import style0 from "./AddDocument.vue?vue&type=style&index=0&id=32790ab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32790ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32790ab2')) {
      api.createRecord('32790ab2', component.options)
    } else {
      api.reload('32790ab2', component.options)
    }
    module.hot.accept("./AddDocument.vue?vue&type=template&id=32790ab2&scoped=true", function () {
      api.rerender('32790ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AddDocument.vue"
export default component.exports